var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "mat-logo.svg",
    viewBox: "-0.01 0 314.52 248.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #b40f23;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #103675;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n        stroke: #000;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        opacity: 0.5;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy",
    "data-name": "Rectangle 1 copy",
    className: "cls-1",
    d: "M272.006,520.347l71.2-158.036L457.325,610.923l-53.546-.471L342.892,470.777a21.1,21.1,0,0,0-6.8-9.128,22.275,22.275,0,0,0-13.443-4.821c-13.877-.339-21.146,18.159-19.835,15.364-24.6,52.443,3.814-4.026-17.919,39.627C284.906,511.842,272.006,520.347,272.006,520.347Z",
    transform: "translate(-142.812 -362.312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.8,609.98L255.973,362.311,370.088,610.923l-54.546-.471L255.656,479.777a21.1,21.1,0,0,0-6.8-9.128,22.274,22.274,0,0,0-13.442-4.821c-13.878-.339-21.147,18.159-19.836,15.364-24.6,52.443-38.154,85.607-59.887,129.26C155.7,610.475,142.8,609.98,142.8,609.98Z",
    transform: "translate(-142.812 -362.312)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.176,500.726l-35.293,74.251a44.929,44.929,0,0,1-16.5,16.511c-10.368,5.738-24.992,7.077-24.992,7.077H149.744L142.8,610.452h56.586s16.577-1.2,27.35-8.02a50.714,50.714,0,0,0,16.5-17.927l34.35-72.364Z",
    transform: "translate(-142.812 -362.312)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.7645a06ef91129d4008580494ed0748f.svg";
export { ForwardRef as ReactComponent };